<template>
  <div>
    <draggable
      :list="recordArray"
      tag="ul"
      v-bind="dragOptions"
      :disabled="!enabled"
      class="list-group"
      ghost-class="ghost"
      :move="checkMove"
      @start="dragging = true"
      @end="dragEnd"
    >
      <!-- <transition-group type="transition" name="flip-list"> -->
      <li class="relationCard" v-for="(item, index) in recordArray" :key="item.ID">
        <span type="danger" class="removeBtn" v-show="enabled" @click="removeRelation(item)">
          <i class="el-icon-delete"></i>
        </span>
        <el-link
          type="primary"
          style="font-weight: bold;margin-bottom:5px"
          @click="showRecordDetail(item.ID)"
        >{{ No(index + 1) }}、{{ item.NAME }}</el-link>
        <p>
          创建人员：{{ item.CREATEUSERNAME }} 创建时间:{{
          item.CREATETIME | timeFormater
          }}
        </p>
        <p>内容：</p>
        <p v-html="item.INFO"></p>
        <RecordTaskRelationTagList
          :relations="item.Relations.filter(o => o.RELATIONTYPE != 2)"
          :closable="isMyCreated(item.CREATEUSERID)"
          @delRelation="delRelation"
        ></RecordTaskRelationTagList>
        <el-row class="filePanel" v-show="item.Files.length > 0">
          <fileListView :fileList="item.Files | fileFormater"></fileListView>
        </el-row>
      </li>
      <!-- </transition-group> -->
    </draggable>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import draggable from "vuedraggable";
import { NoToChinese } from "@/util/common";
import fileListView from "../../../components/common/fileListView.vue";
import RecordTaskRelationTagList from "./RecordTaskRelationTagList";
import {
  SetRecordRelationSort,
  RemoveRecordRelation,
} from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  components: {
    draggable,
    fileListView,
    RecordTaskRelationTagList,
  },
  props: {
    recordArray: {
      type: Array,
      default: [],
    },
    enabled: {
      type: Boolean,
      default: false,
    },
    recordId: {
      type: String,
      default: "",
    },
  },
  filters: {
    fileFormater: (value) => {
      var fileList = [];
      if (value)
        value.forEach((item) => {
          let c = Object.assign({}, item);
          c.ID = this.IMGAPI_ROOT + "api/Task/DownloadFileById?id=" + c.ID;
          fileList.push(c);
        });
      return fileList;
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  data() {
    return {
      dragging: false,
    };
  },
  methods: {
    isMyCreated(userId) {
      console.log(userId + "----" + cookieUser.userId);
      if (userId) return userId === cookieUser.userId;

      return false;
    },
    dragEnd() {
      var list = this.recordArray.map((item, index) => {
        return {
          Name: item.ID.toString(),
          Value: index,
        };
      });
      if (list.length > 0)
        SetRecordRelationSort(list, this.recordId).then((result) => {
          if (result.ResultCode < 0) {
            this.$message.error("排序失败：" + result.MsgInfo);
          }
        });
      this.dragging = false;
    },
    delRelation(val) {
      var row = this.recordArray.find((o) => o.ID == val.RECORDID);
      if (row) row.Relations.splice(row.Relations.indexOf(val), 1);
    },
    removeRelation(val) {
      RemoveRecordRelation(val.ID, this.recordId).then((result) => {
        if (result.ResultCode > 0) {
          this.$emit("removeRecordRelation", val);
          this.dragEnd();
        } else {
          this.$message.error("移除失败：" + result.MsgInfo);
        }
      });
    },
    No(index) {
      return NoToChinese(index);
    },
    isMyCreated(userId) {
      console.log(userId + "----" + cookieUser.userId);
      if (userId) return userId === cookieUser.userId;

      return false;
    },
    showRecordDetail(recordid) {
      let routeUrl = `${location.href.substr(
        0,
        location.href.lastIndexOf("/")
      )}/recordinfo?recordid=${recordid}`;
      console.log(routeUrl);
      window.open(routeUrl, "_blank");
    },
    checkMove: function (e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
.relationCard {
  margin-top: 10px;
  border-radius: 5px;
  // border: 1px dashed #333;
  padding: 5px;
  font-size: 14px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.relationCard:hover {
  // border: 1px dashed #333;
  background: aliceblue;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.removeBtn {
  position: absolute;
  right: 20px;
  font-size: 24px;
  color: #ff7777;
  cursor: pointer;
  visibility: hidden;
}
.relationCard:hover > .removeBtn {
  visibility: visible;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
